import React from 'react';
import { Dialog } from 'primereact/dialog';
import { CalendarEvent } from '../../../pages/course/lectures/calendar/big-calendar/course-lecture-event-calendar';

export interface LectureEventDetailsDialogProps {
  visible: boolean;
  onHide: () => void;
  event: CalendarEvent | null;
}

export const LectureEventDetailsDialog: React.FC<
  LectureEventDetailsDialogProps
> = ({ visible, onHide, event }) => {
  if (!event) return null;
  const {
    title,
    start,
    end,
    lectureId,
    courseName,
    additionalCourseName,
    className,
    isRemote,
  } = event;

  const infoRow = (label: string, value?: React.ReactNode) => {
    if (value === undefined || value === null || value === '') return null;
    return (
      <div style={{ display: 'flex', gap: '8px', marginBottom: '6px' }}>
        <div style={{ minWidth: '110px', fontWeight: 600 }}>{label}:</div>
        <div>{value}</div>
      </div>
    );
  };

  return (
    <Dialog
      header="פרטי מפגש"
      visible={visible}
      onHide={onHide}
      style={{ width: '520px' }}
      modal
    >
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        {infoRow('שם המפגש', title)}
        {infoRow(
          'שעת התחלה',
          start?.toLocaleString('he-IL', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
          }),
        )}
        {infoRow(
          'שעת סיום',
          end?.toLocaleString('he-IL', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
          }),
        )}
        {infoRow('קורס', courseName)}
        {infoRow('שם קורס נוסף', additionalCourseName)}
        {infoRow('כיתה', className)}
        {infoRow('מרחוק', isRemote ? 'כן' : 'לא')}
        {infoRow('מזהה מפגש', lectureId)}
      </div>
    </Dialog>
  );
};
